<template>
    <div class="payment-history-panel">
        <div v-if="title" class="payment-history-panel__title">{{ title }}</div>
        <div v-if="!entries.length" class="payment-history-panel__empty">Chưa có lịch sử thanh toán</div>
        <div v-else class="payment-history-panel__list">
            <div
                v-for="(entry, idx) in entries"
                :key="idx"
                class="payment-history-item"
            >
                <div class="payment-history-item__row">
                    <span class="payment-history-item__index">Lần {{ idx + 1 }}</span>
                    <span class="payment-history-item__time">{{ formatEntryDate(entry.date) }}</span>
                </div>
                <div v-if="showTransactionCode" class="payment-history-item__code-row">
                    <template v-if="entry.code">
                        <code :title="entry.code" class="payment-history-item__code">{{ entry.code }}</code>
                        <button
                            class="payment-history-item__copy"
                            title="Sao chép mã giao dịch"
                            type="button"
                            @click="$emit('copy', entry.code)"
                        >
                            <i class="el-icon-document-copy"></i>
                        </button>
                    </template>
                    <span v-else class="payment-history-item__muted">Không có mã GD</span>
                </div>
            </div>
        </div>
        <p v-if="hint" class="payment-history-panel__hint">{{ hint }}</p>
    </div>
</template>

<script>
import moment from "moment-timezone";

export default {
    name: "PaymentHistoryPanel",
    props: {
        entries: {
            type: Array,
            default: () => [],
        },
        showTransactionCode: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Lịch sử thanh toán",
        },
        hint: {
            type: String,
            default: "",
        },
    },
    methods: {
        formatEntryDate(value) {
            if (!value) return "—";
            const m = moment(value);
            return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : value;
        },
    },
};
</script>

<style scoped>
.payment-history-panel {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
}

.payment-history-panel__list {
    max-height: min(320px, 50vh);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 2px 4px 2px 0;
    margin-right: -2px;
}

.payment-history-panel__title {
    font-weight: 600;
    font-size: 13px;
    color: #111827;
    margin-bottom: 10px;
}

.payment-history-panel__empty {
    font-size: 13px;
    color: #9ca3af;
    padding: 8px 0;
}

.payment-history-item {
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fafafa;
}

.payment-history-item + .payment-history-item {
    margin-top: 8px;
}

.payment-history-item__row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    min-width: 0;
}

.payment-history-item__index {
    flex-shrink: 0;
    display: inline-block;
    min-width: 52px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #ede9fe;
    color: #5e00b6;
    font-size: 11px;
    font-weight: 600;
    text-align: center;
}

.payment-history-item__time {
    font-size: 13px;
    font-weight: 500;
    color: #111827;
    min-width: 0;
    flex: 1 1 auto;
}

.payment-history-item__code-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #e5e7eb;
    min-width: 0;
}

.payment-history-item__code {
    flex: 1;
    min-width: 0;
    display: block;
    padding: 6px 10px;
    border-radius: 6px;
    background: #fff;
    border: 1px solid #e5e7eb;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
    line-height: 1.45;
    color: #374151;
    word-break: break-all;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
    max-height: 4.5em;
    overflow-y: auto;
}

.payment-history-item__copy {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    color: #5e00b6;
    cursor: pointer;
    line-height: 1;
}

.payment-history-item__copy:hover {
    background: #f3e8ff;
    border-color: #c4b5fd;
}

.payment-history-item__muted {
    font-size: 12px;
    color: #9ca3af;
}

.payment-history-panel__hint {
    margin: 10px 0 0;
    font-size: 12px;
    color: #6b7280;
    line-height: 1.4;
}
</style>
